import {useContext, useEffect, useRef, useState} from "react";
import ScrollerChild from "./ScrollerChild";
import Main from "../../../containers/Main";
import Formation from "../../../containers/Formation";
import styles from "./index.module.css";
import ScrollerNavigation from "./ScrollerNavigation";
import { ThemeContext } from "../../../contexts/theme";
import useScrollSum from "../../../lib/use/useScrollSum";

const MAX_SCROLL = 100;

const ScrollerContainer = ({ pages, pageNumber, setPageNumber }) => {
  const refChilds = [];
  const [scrollSum,setScrollSum] = useScrollSum(MAX_SCROLL);
  const [block, setBlock] = useState(false);
  const calculatePosChild = (i) => {
    return i * 100 - pageNumber * 100;
  };
  const limitScroll = () => {
    setBlock(true);
    setTimeout(() => {
      setBlock(false);
    }, 1000);
  };

  useEffect(() => {
      let testNext =
        Math.ceil(refChilds[pageNumber].current.scrollTop) >=
        refChilds[pageNumber].current.scrollHeight -
          refChilds[pageNumber].current.offsetHeight;
      let testPrev = refChilds[pageNumber].current.scrollTop == 0;

      if (block) return
      if (!testNext && !testPrev) return setScrollSum(0);

      if (testPrev && scrollSum < -MAX_SCROLL){
          limitScroll();
          setPageNumber("prev");
      }
      else if (testNext && scrollSum > MAX_SCROLL){
          limitScroll();
          setPageNumber("next");
      }
  }, [scrollSum]);

  return (
    <div
      className={styles.sliderContainer}

    >
      <div
          style={{
              position: "relative",
              top: `${-scrollSum * 0.1}px`
          }}
        className={styles.sliderChildrenList}
      >
        {pages.map((page, i) => {
          let temp = useRef();
          refChilds.push(temp);
          return (
            <ScrollerChild refChild={temp} key={i} pos={calculatePosChild(i)}>
              {page.root({
                isInView: i == pageNumber ? true : false,
                setBlock,
              })}
            </ScrollerChild>
          );
        })}
      </div>
      <ScrollerNavigation
        pageNumber={pageNumber}
        pageLength={pages.length}
        setPageNumber={setPageNumber}
      />
    </div>
  );
};

export default ScrollerContainer;
